import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import {
  FaUserCheck,
  FaIdCard,
  FaExternalLinkAlt,
  FaListAlt,
  FaCheckCircle,
  FaFileUpload,
} from "react-icons/fa";
import FAQSchema from "../../FAQSchema";
import { BadgeCheck, FileText } from "lucide-react";

const Equitas = () => {
  const [CreditCardData, setCreditCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(10);
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };

  function Icon({ id, open }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className={`${
          id === open ? "rotate-180" : ""
        } h-5 w-5 transition-transform`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19.5 8.25l-7.5 7.5-7.5-7.5"
        />
      </svg>
    );
  }

  useEffect(() => {
    Http.post(CARD_API)
      .then((res) => {
        setCreditCardData(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  console.log({ indexOfLastCard, indexOfFirstCard });
  const currentCards = CreditCardData.cards
    ?.filter((card) => card.title?.toLowerCase().includes("equitas"))
    .slice(indexOfFirstCard, indexOfLastCard);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const faqs = [
    {
      question: "Do Equitas credit cards come with joining fees?",
      answer:
        "Many Equitas cards are either lifetime free or have minimal joining fees, with options for spend-based annual fee waivers.",
    },
    {
      question: "Can I apply if I don’t have a credit history?",
      answer:
        "Yes, Equitas encourages first-time credit users, especially existing customers, to start building their credit profile with a basic card.",
    },
    {
      question: "Is there any cashback or reward point program?",
      answer:
        "Yes, Equitas offers reward points on dining, groceries, and utility bills, along with periodic cashback campaigns and EMI options.",
    },
    {
      question: "How can I repay my credit card bills?",
      answer:
        "You can repay via internet banking, UPI, NEFT, or set up auto-pay mandates from your Equitas account.",
    },
    {
      question: "Is the card manageable via a mobile app?",
      answer:
        "Absolutely. Use the Equitas Mobile Banking App to track spends, view statements, pay bills, and manage card limits and alerts in real-time.",
    },
  ];

  const steps = [
    {
        icon: <FaCheckCircle className="h-6 w-6 text-orange-500" />,
        title: "Check Eligibility",
        description:
          "Confirm whether your age, income, employment status, and location align with Equitas's card issuance policy.",
      },
      {
        icon: <FaFileUpload className="h-6 w-6 text-green-500" />,
        title: "Prepare Necessary Documents",
        description:
          "Keep your KYC documents and income proofs ready for smooth processing and fast-track approval.",
      },
      {
        icon: <FaExternalLinkAlt className="h-6 w-6 text-purple-600" />,
        title: "Apply Through Equitas Bank's Official Portal",
        description:
          "Once you've finalized a card, click 'Apply Now' to proceed to the official Equitas Small Finance Bank website for secure and authenticated application submission.",
      },
    {
      icon: <FaListAlt className="h-6 w-6 text-teal-500" />,
      title: "Explore & Compare with TheFinMaster",
      description:
        "Discover the top Equitas credit cards on TheFinMaster. We list each card with full details—features, benefits, reward systems, applicable charges, and ideal users—so you can make an informed choice that suits your lifestyle and budget.",
    },
    
  ];

  return (
    <>
      <Helmet>
        <title>
        Equitas Bank Credit Cards – Compare & Apply Online
        </title>
        <meta
          name="description"
          content="Discover Equitas Bank credit cards tailored to your needs. Compare features and apply online effortlessly."
        />
        <meta
          name="keywords"
          content="equitas small finance bank credit card, equitas credit card apply, equitas credit card benefits, equitas credit card eligibility, equitas sfb credit card"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/equitas-bank/credit-card"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      <div className="w-full flex flex-col items-center ">
        <div className="w-full flex flex-col items-center ">
          <div className=" mt-10 w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600">
            <h1 className="text-white text-4xl md:text-7xl text-center font-medium">
              Credit Card
            </h1>
            <p className="text-gray-200 text-lg md:text-2xl pt-2 px-4 text-center">
              Experience financial freedom and flexibility with our credit card
              options.
            </p>
          </div>
        </div>
        <div className="flex justify-center items-center  p-4">
          <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
              Practical, Accessible, and Rewarding Credit Options for Everyone
            </h2>

            <p className="text-gray-600 leading-relaxed mt-3">
              Equitas Small Finance Bank offers credit cards that are designed for
              smart, inclusive banking. Focused on everyday savings and ease of
              access, their cards are ideal for emerging users, salaried
              individuals, and small business owners. With affordable charges,
              transparent policies, and relevant rewards, Equitas ensures that
              your credit journey starts on the right foot and stays financially
              beneficial over time.
            </p>
          </div>
        </div>
        <h1 className="text-center text-2xl md:text-3xl font-bold text-gray-800 my-10">
          Featured Credit Cards
        </h1>
        <div className="w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10">
          <div className="w-fit flex flex-col gap-8">
            {currentCards &&
              currentCards.map((item, index) => {
                return (
                  <>
                    {" "}
                    <CardComponent
                        key={index}
                        cardDetails={item}
                        Card_features={item?.Card_features}
                        fees={item?.fees}
                        cardName={item?.title}
                        cardImage={item?.image}
                        rating={item?.rating}
                        category={item?.category}
                        status={item?.status}
                        bank_link={item?.bank_link}
                    />{" "}
                  </>
                );
              })}
          </div>

            <div className="w-full relative ">
                    <div className="sticky overflow-hidden top-20 w-full h-[500px] flex flex-col justify-between">
                      {/* <div className="w-[70%] mx-auto">
                                                                   <h2 className="text-center font-medium pt-5 text-lg">
                                                                     <span className="font-semibold text-white">816 people</span>{" "}
                                                                     are on call with our advisors right now
                                                                   </h2>
                                                                 </div> */}
                      <div className="w-full mx-auto">
                        <Link
                          to="https://play.google.com/store/apps/details?id=com.fatakpay&pcampaignid=web_share"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <div className="w-[80%] mx-auto ">
                            <img src="/assets/ftak.jpg" alt="Advertisement" />
                          </div>
                        </Link>
                        <div className="bg-white">
                          {/* <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                                                                       Know your advisor
                                                                     </h3> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
        {/* Pagination */}
        <ul className="flex justify-center mt-4">
          {currentCards &&
            CreditCardData.cards?.filter(
              (card) => card.category === "Credit card"
            ).length > 0 &&
            Math.ceil(
              CreditCardData.cards?.filter(
                (card) => card.category === "Credit card"
              ).length / cardsPerPage
            ) > 1 &&
            Array.from({
              length: Math.ceil(
                CreditCardData.cards?.filter(
                  (card) => card.category === "Credit card"
                ).length / cardsPerPage
              ),
            }).map((_, index) => (
              <li key={index} className="mx-1">
                <button
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>

       

        <div className="w-full px-2 py-2 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
          <div className="max-w-6xl mx-auto grid gap-10">
            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <FileText className="w-8 h-8 text-sky-600" />
                <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                  Eligibility Criteria to Apply for Equitas Small Finance Bank
                  Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Age Requirement
                  </span>
                  <span>
                    Applicants must be between 21 and 60 years for primary cards.
                    Add-on cards may be issued to dependents aged 18 years and
                    above.
                  </span>
                </div>

                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Minimum Income Requirement
                  </span>
                  <span>
                    For salaried individuals, a net monthly income of ₹15,000 or
                    more is typically required. Self-employed professionals may be
                    required to show bank statements or ITRs to validate steady
                    income.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Credit Score
                  </span>
                  <span>
                    A CIBIL score of 700+ is generally expected. However, Equitas
                    may consider thin-file or new-to-credit users, especially
                    those with a relationship account.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Employment Type
                  </span>
                  <span>
                    Salaried employees, self-employed professionals,
                    entrepreneurs, and small-scale traders are all eligible,
                    promoting financial inclusion.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Banking Relationship
                  </span>
                  <span>
                    Applicants with an existing Equitas savings or salary account
                    may receive faster approvals and relaxed eligibility norms.
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <BadgeCheck className="w-8 h-8 text-emerald-600" />
                <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                  Documents Required to Apply for Equitas Small Finance Bank
                  Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Identity
                  </span>
                  <span>
                    Government-issued ID such as Aadhaar, Voter ID, Passport, or
                    Driving License for KYC validation.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Address
                  </span>
                  <span>
                    Utility bill, Aadhaar card, rent agreement, or bank passbook
                    with address can be submitted.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Income Proof
                  </span>
                  <span>
                    Salaried: 3 months’ salary slips or Form 16. Self-employed:
                    6-month bank statement or ITR (latest year).
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    PAN Card
                  </span>
                  <span>
                    Compulsory for all applicants to track credit history and
                    comply with regulatory norms.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Photograph
                  </span>
                  <span>
                    One recent passport-sized color photograph is needed for
                    offline verification and records.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-4 py-10 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-4">
          How to Apply for Equitas Small Finance Bank Credit Card
        </h2>
        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start gap-4 p-4 rounded-xl bg-white dark:bg-gray-900 shadow-md border hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mt-1">{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{`${
                  index + 1
                }. ${step.title}`}</h3>
                <p className="text-md text-gray-600 dark:text-gray-300">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h1 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h1>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Equitas;